import React from 'react';
import { Layout, GetInfo } from '../components';

const Sponsors = () => {
  return (
    <div className="Sponsors">
      <Layout bannerId={76}>
        <div className="container">
          <GetInfo id={143}/>
        </div>
      </Layout>
    </div>
  );
};

export default Sponsors;
